import FullCalendar from '@fullcalendar/react'
import classes from './calendar.module.css'

export default function Calendar(props) {
  return (
    <FullCalendar
      {...props}
    />
  )
}